import { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const { language, setLanguage } = useLanguage();
    const t = translations[language];

    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        const sections = ['intro', 'id-section-services', 'about', 'join-team', 'contact'];

        const handleScroll = () => {
            let found = false;

            for (const id of sections) {
                const el = document.getElementById(id);
                if (el) {
                    const rect = el.getBoundingClientRect();
                    if (rect.top <= 100 && rect.bottom >= 100) {
                        setActiveSection(id);
                        found = true;
                        break;
                    }
                }
            }

            if (!found) {
                setActiveSection('');
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [activeSection]);


    return (
        <div className="seccion-header">
            <div className={`nav-content shadow-content w-nav ${menuOpen ? 'w--open' : ''}`}>
                <div className="container">
                    <div className="nav-wrapper">
                        <Link to="/" className="nav-brand w-nav-brand">
                            <img src="/images/logo.svg" width={32} alt="Logo" loading="lazy" />
                            <div className="title-company">CASTLETECH LLC</div>
                        </Link>

                        <div className="w-nav-button" onClick={() => setMenuOpen(!menuOpen)}>
                            <div className="w-icon-nav-menu"></div>
                        </div>

                        <nav
                            role="navigation"
                            className={`nav-menu-wrapper w-nav-menu ${menuOpen ? 'w--nav-menu-open' : ''}`}
                        >
                            <ul role="list" className="nav-meno-two w-list-unstyled">
                                <li className="list-item">
                                    <a
                                        href="#intro"
                                        className={`nav-link ${activeSection === 'intro' ? 'w--current' : ''}`}
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        {t.navbar.home}
                                    </a>
                                </li>
                                <li className="list-item">
                                    <a
                                        href="#id-section-services"
                                        className={`nav-link ${activeSection === 'id-section-services' ? 'w--current' : ''}`}
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        {t.navbar.services}
                                    </a>
                                </li>
                                <li className="list-item">
                                    <a
                                        href="#about"
                                        className={`nav-link ${activeSection === 'about' ? 'w--current' : ''}`}
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        {t.navbar.about}
                                    </a>
                                </li>
                                <li className="list-item">
                                    <a
                                        href="#contact"
                                        className={`nav-link ${activeSection === 'contact' ? 'w--current' : ''}`}
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        {t.navbar.contact}
                                    </a>
                                </li>
                                <li className="list-item">
                                    <a
                                        href="#join-team"
                                        className={`nav-link ${activeSection === 'join-team' ? 'w--current' : ''}`}
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        {t.navbar.join}
                                    </a>
                                </li>
                                {/* Dropdown de idioma */}
                                <li className="list-item">
                                    <div className="icon-header w-inline-block" onClick={() => setDropdownOpen(!dropdownOpen)}>
                                        <img src="/images/world-white.svg" width={26} alt="lang" className="image-header" />
                                    </div>
                                    <div className="nav-dropdown w-dropdown">
                                        <div className="nav-dropdown-toggle w-dropdown-toggle" onClick={() => setDropdownOpen(!dropdownOpen)}>
                                            <div className="nav-dropdown-icon w-icon-dropdown-toggle"></div>
                                            <div className="text-item">{language.toUpperCase()}</div>
                                        </div>
                                        <nav className={`nav-dropdown-list shadow-nav-three mobile-shadow-hide w-dropdown-list ${dropdownOpen ? 'w--open' : ''}`}>
                                            <a href="#" onClick={() => { setLanguage('en'); setDropdownOpen(false); }} className="nav-dropdown-link w-dropdown-link">US English</a>
                                            <a href="#" onClick={() => { setLanguage('es'); setDropdownOpen(false); }} className="nav-dropdown-link w-dropdown-link">ES Español</a>
                                        </nav>
                                    </div>
                                </li>

                                {/* Redes sociales en móvil */}
                                <li className="list-item mobile-social-icons">
                                    <a href="#" className="icon-header w-inline-block">
                                        <img src="/images/facebook-white.svg" width={26} alt="Facebook" />
                                    </a>
                                    <a href="#" className="icon-header w-inline-block">
                                        <img src="/images/instagram-white.svg" width={26} alt="Instagram" />
                                    </a>
                                    <a href="#" className="icon-header w-inline-block">
                                        <img src="/images/twitter-white.svg" width={26} alt="Twitter" />
                                    </a>
                                </li>
                            </ul>
                        </nav>


                        <div className="header-social-block">
                            <a href="#" className="icon-header w-inline-block">
                                <img src="/images/facebook-white.svg" width={26} alt="Facebook" />
                            </a>
                            <a href="#" className="icon-header w-inline-block">
                                <img src="/images/instagram-white.svg" width={26} alt="Instagram" />
                            </a>
                            <a href="#" className="icon-header w-inline-block">
                                <img src="/images/twitter-white.svg" width={26} alt="Twitter" />
                            </a>
                        </div>
                    </div>
                    <div className="nav-line" style={menuOpen ? { display: 'none' } : { display: 'flex' }}>
                        {t.navbar.calendar}
                        <a href="https://adriancastillo-castillo.youcanbook.me/" target="_blank" rel="noopener noreferrer" className="nav-line-link">
                            {t.navbar.boton}
                        </a>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Navbar;
